module.exports = "/images/vendor/flag-icon-css/flags/1x1/wf.svg?05522b9f19236d09cc79eee2588b6992";